import React, { FC } from 'react';
import { logo } from '../assets/base64';
import { Image } from '../components/Image';
import { IS_WEB } from '../constants/platform';
import { addBase64Prefix } from '../services/addBase64Prefix';
import { TouchableOpacity } from 'react-native';
import { NavigationService } from '../services/navigation';
import { useSelector } from 'react-redux';
import { RootState } from '../services/redux';

const HeaderMobileLeft: FC = () => {
  const auth = useSelector((redux: RootState) => redux.authReducer);

  return (
    <TouchableOpacity
      onPress={() => {
        NavigationService.push('Root', {
          screen: 'HomeTab',
        });
      }}
    >
      <Image
        source={IS_WEB ? addBase64Prefix(logo) : require('../assets/logo.png')}
        style={{ width: 45, height: 45, resizeMode: 'contain' }}
      />
    </TouchableOpacity>
  );
};

export default HeaderMobileLeft;
